import * as exInstance from '../../utils/instance';

import exManager from './manager';

// ----------------------------------------------------------------------------

const instance = new exInstance.instanceManager();

// ----------------------------------------------------------------------------

export type TypeManagerConfig = Record<string, any>;
export type TypeManagerApi = ReturnType<typeof exManager>;
export type TypeMountManyElements = HTMLTableElement[] | NodeListOf<HTMLTableElement>;

// ----------------------------------------------------------------------------

function mount(element: HTMLTableElement, config: TypeManagerConfig = {}): TypeManagerApi | undefined {
    if (!(element instanceof HTMLTableElement)) {
        throw new Error('The element is not HTMLTableElement!');
    }

    if (!instance.has(element)) {
        const managerDatatable = exManager(element, config);
        instance.add(element, managerDatatable);
    }

    return instance.get(element);
}

function mountMany(elements: TypeMountManyElements, config: TypeManagerConfig = {}): TypeManagerApi[] {
    const instances: TypeManagerApi[] = [];

    for (const element of elements) {
        const instance = mount(element, config);

        if (instance) {
            instances.push(instance);
        }
    }

    return instances;
}

// ----------------------------------------------------------------------------

export { mount, mountMany };
